import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  stickyBannerWrapper: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    transition: 'transform .3s ease',
  },
  banner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 24px',
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.orange.orange,
    borderRadius: '10px 10px 0 0',
  },
  textPart: {
    fontSize: theme.fonts.sizes.fonL,
    fontWeight: 700,
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    minWidth: 0,
    width: 32,
    height: 24,
    marginBottom: 0,
    borderRadius: 50,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    border: `1px solid ${theme.colors.light.freshPowder}`,

    '&:hover': {
      backgroundColor: theme.colors.orange.orange,
    },
  },
}));
